import React, { useEffect, useState } from 'react';
import genStyles from '../generale.module.css';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { 
    currentPageParcelleAtom,
    geoJsonMapState, 
    sortConfigParcelleAtom
} from '../../atoms/ModalCollectionState';
import { 
    apiCollectionState,
    apiPciState,
    collectionsState,
    loadingState,
    reloadCollectionState,
    reloadEntiteState,
    toastState,
    userDataState
} from '../../atoms/CollectionState';
import ModalCollectionService from '../../service/ModalCollectionService';
import ReactSwitch from 'react-switch';
import ShowService from '../../service/showService';
import ResultForm from '../resultat/resultatForm';
import TooltipForm from '../tooltipForm';
import { DropdownSelect } from '../dropdownSelect';
import CollectionService from '../../service/CollectionService';


export default function ModalCollectionForm({ onClose }) {
    const api_pci = useRecoilValue(apiPciState);  
    const api_collection = useRecoilValue(apiCollectionState);
    const geoJsonMap = useRecoilValue(geoJsonMapState); 
    const collections = useRecoilValue(collectionsState);  
    const [collectionChoice, setCollectionChoice] = useState("new");
    const [collectionName, setCollectionName] = useState("");
    const [fusion, setFusion] = useState(false);
    const [switchColor, setSwitchColor] = useState('#86d3ff');
    const [entites, setEntites] = useState([]);
    const [currentPageEntity, setCurrentPageEntity] = useRecoilState(currentPageParcelleAtom);
    const [sortConfigEntity, setSortConfigEntity] = useRecoilState(sortConfigParcelleAtom);
    const [openEdit, setOpenEdit] = useState(false);
    const [firstmoment, setFirstmoment] = useState(false);
    const user_data = useRecoilValue(userDataState);  
    const [form, setForm] = useState([]);
    const [layerEdit, setLayerEdit] = useState(null);     
    const setToast = useSetRecoilState(toastState);       
    const setLoading = useSetRecoilState(loadingState);   
    const setReloadEntite = useSetRecoilState(reloadEntiteState);   
    const setReloadCollection = useSetRecoilState(reloadCollectionState); 

    useEffect(() => {  
        setEntites([]);
        setForm([]);
        setCollectionName('');
        setCollectionChoice('new')
        setLayerEdit(null);
        setFirstmoment(true);
        ModalCollectionService.init(geoJsonMap,user_data.user.id);
        getSelectParcelle();

        // Récupérer la variable CSS définie dans :root
        const color = getComputedStyle(document.documentElement)
          .getPropertyValue('--main-color-first')
          .trim();
        if (color) {
            const formatcolor = ShowService.getColorFormat(color);
            switch (formatcolor) {
                case 'hex':
                    setSwitchColor(color);
                  break;
                case 'rgba':
                case 'rgb':
                    setSwitchColor(ShowService.rgbToHex(color));
                  break;
                  default : setSwitchColor('#86d3ff');
            }
          
        }
    }, []);

    
    useEffect(() => {  
        let layerjson ;
        setLayerEdit(null);
        setEntites([]);
        setForm([]);
        setOpenEdit(false);
        if(fusion){
            fusionParcelles();
        }else{
            defusionParcelles();
        }
        if(layerjson && firstmoment){
            setEntites(layerjson);            
        }  
       
    }, [fusion]);

    const defusionParcelles = () => {
        const ageojson = ModalCollectionService.defusionnerParcelles();
        ageojson.forEach(geojson => {
            const layerjson = ModalCollectionService.drawParcelleInMap(geojson);
            setEntites(prev => [...prev, layerjson]);
        });
    };

    const fusionParcelles = () => {
        const ageojson = ModalCollectionService.getListFusion();
        ageojson.forEach(geojson => {
            const layerjson = ModalCollectionService.drawParcelleInMap(geojson);
            setEntites(prev => [...prev, layerjson]);
        });
    };

    const getSelectParcelle = () => {
        const allParcelles = geoJsonMap.features.flatMap(f => {
            const idu = f.properties?.idu || f.properties?.id_par;
            return f.properties.parcelles_found ?? (idu ? [idu] : []);
        });
        
        allParcelles.forEach(idpar => {
            ModalCollectionService.fetchParcelle(api_pci,idpar).then((response) => {
                if(response.type === "FeatureCollection"){
                    const layerjson = ModalCollectionService.drawParcelle(response);
                    setEntites(prev => [...prev, layerjson]);
                }
            });
        });
       
    };

    const onValidate = () => {
        if(collectionChoice == 'new'){
            if(collectionName && collectionName.trim() != ''){
                setLoading(true);
                const urlApi = api_collection+ user_data.account.port+ '/';
                const userId = user_data.user.id;
                CollectionService.addCollection(urlApi,userId,collectionName).then((response) => { 
                    if(response.id){
                        addEntiteToDataBase(response.id);                                             
                    } else {
                        setToast({ message: response.message , type: 'error' });
                    }  
                });
            }else{
                setToast({ message: 'Il vous faut choisir ou créer une collection pour ajouter les entités' , type: 'warning' });
            }
        }else{
            setLoading(true);
            addEntiteToDataBase(collectionChoice);
        }
      
    };

    const addEntiteToDataBase = async (idcollection) => {
        const listentite = ModalCollectionService.getEntiteToAdd();
        const urlApi = api_collection + user_data.account.port + '/';
        const userId = user_data.user.id;
        if(listentite && listentite.length > 0){
            // On crée une liste de promesses
            const promises = listentite.map((entite) =>
                CollectionService.addEntite(urlApi, userId, entite, idcollection)
            );

            try {
                // On attend que toutes les requêtes soient terminées
                const responses = await Promise.all(promises);

                // Vérification des réponses
                const successCount = responses.filter(r => r?.id).length;

                if (successCount > 0) {
                    setToast({ message: 'Entités créées avec succès', type: 'success' });
                } else {
                    setToast({ message: 'Aucune entité ajoutée', type: 'warning' });
                }

            } catch (error) {
                setToast({ message: 'Erreur lors de la création des entités', type: 'error' });
            } finally {
                setReloadCollection(true);
                setReloadEntite(true);
                setLoading(false);
                onClose();
            }
        }else{
            setToast({ message: 'Erreur lors de la création des entités', type: 'error' });
            setLoading(false);
            onClose();
        }
        
    };    

    const zoomEntite = (entite) => {
        ModalCollectionService.zoomentite(entite.geojson);
    };

    const editeEntite = (entite) => {
        setLayerEdit(entite.id);
        let formData = {};
        ModalCollectionService.zoomentite(entite.geojson);
        const retdata = ModalCollectionService.getProperties(entite);
        formData = {
            nomEntite: retdata.titre,
            observation: retdata.observation,
            polycontourColor: retdata.options?.color ?? '#92bbf4',
            polycontourOpacity: retdata.options?.opacity ?? '1',
            polycontourEpaisseur: retdata.options?.weight ?? '3',
            polyColor: retdata.options?.fillColor ?? retdata.options?.color,
            polyOpacity: retdata.options?.fillOpacity ?? '0.2',
            measure : retdata.measure ?? false, 
          };
        setForm(formData);
        setOpenEdit(true);
    };
    
    const columns = [
        { key: 'nom', label: "Nom de l'entité", selectable: false, sortable:true },
        {
            key: 'actions',
            sortable: false,
            label: '',
            subColumns: [
            { key: 'action1', label: '' },
            { key: 'action2', label: '' },
            ],
            render: (_, row) =>  [
                <td key={`zoom-${row.id}`} style={{width:'30px'}} className='center-align'>
                    <a  onClick={() => zoomEntite(row)} >
                        <TooltipForm content={`Zoomer sur l'entité`}>
                        <i className={`fa-solid fa-magnifying-glass-plus yellow-text text-darken-3 ${genStyles.fontSize16}`}></i>
                        </TooltipForm>
                    </a>
                </td>,
                <td key={`intersec-${row.id}`} style={{width:'30px'}} className='center-align'>
                    <a  onClick={() => editeEntite(row)} >
                        <TooltipForm content={`Modifier l\'entité`}>
                        <i className={`fa-solid fa-pen-to-square bgcolor_first-text text-darken-3 ${genStyles.fontSize16}`}></i>
                        </TooltipForm>
                    </a>
                </td>,
            ]
        }
    ];

    const updateField = (key, value) => {
        if(key === "nomEntite"){
            setEntites((prev) =>
                prev.map((entite) =>
                  entite.id === layerEdit
                    ? { ...entite, nom: value } 
                    : entite 
                )
            );
        }
        setForm((prev) => {
            let updatedValue = value; 
            // Si on modifie la transparence, convertir % en valeur 0-1
            if (key === "polycontourOpacity" || key === "polyOpacity") {
                const numericValue = parseFloat(value);
                if (!isNaN(numericValue)) {
                    updatedValue = numericValue / 100;
                } else {
                    updatedValue = 0;
                }
            }
            const updatedForm = { ...prev, [key]: updatedValue };
            const updatedLayer = ModalCollectionService.updatePropertieLayer(updatedForm, layerEdit);            
            return updatedForm;
        });
    };

    const presetColors = [
        { name: "#36c980", iconClass: "#36c980" },
        { name: "#a0d44f", iconClass: "#a0d44f" },
        { name: "#c9b957", iconClass: "#c9b957" },
        { name: "#face47", iconClass: "#face47" },
        { name: "#7945ca", iconClass: "#7945ca" },
        { name: "#a15bd5", iconClass: "#a15bd5" },
        { name: "#6499f4", iconClass: "#6499f4" },
        { name: "#76cbf9", iconClass: "#76cbf9" },
        { name: "#b63453", iconClass: "#b63453" },
        { name: "#db465e", iconClass: "#db465e" },
        { name: "#f61e87", iconClass: "#f61e87" },
        { name: "#f75cbf", iconClass: "#f75cbf" },
        { name: "#f7683c", iconClass: "#f7683c" },
        { name: "#f7af54", iconClass: "#f7af54" },
        { name: "#7d5247", iconClass: "#7d5247" },
        { name: "#818181", iconClass: "#818181" },
        { name: "#252525", iconClass: "#252525" },
        { name: "#FFFFFF", iconClass: "#FFFFFF" },
    ];

    return (
        <div className={`${genStyles.modalCollFrm} row mb0`} >
            <div className="col s12">
                <p className={`${genStyles.fontSize22} ${genStyles.uppercase} ${genStyles.bold} center-align bgcolor_first-text`} >
                Transformer votre selection en collection 
                </p>
            </div>
            <div className="col s6">
                <div className="row">
                    <div className="col s12 mb20">
                        <div className="row">
                            <div className="col s6 mb10">
                                <span className={`${genStyles.fontSize15}  bgcolor_first-text`}>Choisir une collection existante</span>
                                <select 
                                    className={genStyles.selectCol}                                    value={collectionChoice}
                                    onChange={(e) => setCollectionChoice(e.target.value)}
                                >
                                    <option value="new">Nouvelle collection</option>
                                    {collections.map((element) => (
                                        <option key={element?.id} value={element?.id}>
                                            {element?.nom_affiche || element?.nom_collection}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            {collectionChoice === "new" && (
                                <div className="col s6  mb10">
                                    <span className={`${genStyles.fontSize15}  bgcolor_first-text`}>Créer une collection</span>
                                    <input 
                                        className={genStyles.inputtCol}
                                        type="text" 
                                        placeholder="Nom de la collection"
                                        value={collectionName} 
                                        onChange={(e) => setCollectionName(e.target.value)}
                                    />
                                </div>
                            )}
                            {entites && (
                            <>
                                <div className="col s12 center-align">
                                    <ResultForm 
                                        data={entites} 
                                        columns={columns} 
                                        pageSize={5} 
                                        tableHeight="auto" 
                                        textpaginate="parcelle" 
                                        textnone="Aucune parcelle"
                                        currentPage={currentPageEntity}
                                        setCurrentPage={setCurrentPageEntity}
                                        sortConfig={sortConfigEntity}
                                        setSortConfig={setSortConfigEntity}
                                    />
                                </div>
                            </>      
                            )}
                        </div>
                    </div>
                    <div className="col s12">
                        <div className={genStyles.modal_collection_map_modal} id="map_modal"></div>
                    </div>
                </div>
            </div>
            <div className="col s6">
                <div className="row">
                    <div className="col s12">
                        <div className="row mb0">
                            <div className={`col s12 ${genStyles.ctnswitch} ${genStyles.interbottom}`}>
                                <span className={`${genStyles.fontSize15}  black-text  ${genStyles.noMargin}`}>Fusionner les parcelles</span>
                                <ReactSwitch
                                    onChange={(checked) => setFusion(checked)}
                                    checked={!!fusion}
                                    onColor={switchColor}
                                    offColor="#bbbbbb"
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    height={20}
                                    width={40}
                                />
                            </div>
                        </div>
                        {openEdit && (
                        <div id="parametre_modal_collection">
                            <div className={genStyles.editFormSection}>
                                {/* --- Info générale --- */}
                                <div className={genStyles.titleedsection}>
                                    <i className={`fa-solid fa-square-info ${genStyles.fontSize18} ${genStyles.icomargin}`}></i>
                                    <span className={`${genStyles.fontSize16} ${genStyles.bold} ${genStyles.bgcolorfirsttext}`}>
                                    Information générale
                                    </span>
                                </div>
                                <div className="row mb0">
                                    <div className="col s12 mb20">
                                        <span className={`${genStyles.fontSize15} black-text`}>
                                        Nom de l'entité
                                        </span>
                                        <input 
                                            className={genStyles.inputtCol}
                                            type="text"
                                            placeholder="Donner un nom à votre entité"
                                            value={form.nomEntite}
                                            onChange={(e) => updateField("nomEntite", e.target.value)}
                                        />
                                    </div>
                                   
                                    <div className="col s12 mb0">
                                        <span className={`${genStyles.fontSize15} black-text`}>
                                        Observation 
                                        </span>
                                        <div
                                            className={`${genStyles.observationPreview}`}
                                            dangerouslySetInnerHTML={{ __html: form.observation}}
                                        />
                                    </div>
                                </div>
                            </div>
                            {/* --- Paramètres géographiques --- */}
                            <div className={genStyles.editFormSection}>
                                <div className={genStyles.titleedsection}>
                                    <i className={`fa-solid fa-vector-polygon ${genStyles.fontSize18} ${genStyles.icomargin}`}></i>
                                    <span className={`${genStyles.fontSize16} ${genStyles.bold} ${genStyles.bgcolorfirsttext}`}>
                                    Paramètres géographiques
                                    </span>
                                </div>
                                <div className="row mb0">
                                    <div className={`col s12 ${genStyles.ctnswitch}`}>
                                        <span className={`${genStyles.fontSize15}  black-text  ${genStyles.noMargin}`}>Afficher les mesures</span>
                                        <ReactSwitch
                                            onChange={(checked) => updateField("measure", checked)}
                                            checked={!!form.measure}
                                            onColor={switchColor}
                                            offColor="#bbbbbb"
                                            uncheckedIcon={false}
                                            checkedIcon={false}
                                            height={20}
                                            width={40}
                                        />
                                    </div>
                                </div>
                            </div>
                             {/* --- Style --- */}
                            <div className={genStyles.editFormSection}>
                                <div className={genStyles.titleedsection}>
                                    <i className={`fa-solid fa-palette ${genStyles.fontSize18} ${genStyles.icomargin}`}></i>
                                    <span className={`${genStyles.fontSize16} ${genStyles.bold} ${genStyles.bgcolorfirsttext}`}>
                                    Styles
                                    </span>
                                </div>
                                <div className="row mb10">
                                    <div className="col s4">
                                        <span className={`${genStyles.fontSize15}  black-text  ${genStyles.noMargin}`}>Contour</span>
                                        <div className={genStyles.pickctn}>
                                            <DropdownSelect
                                                options={presetColors}
                                                selected={form.polycontourColor}
                                                onChange={(color) => updateField("polycontourColor", color)}
                                                type="color"
                                                showCustomColor={true}
                                            />                               
                                            <input 
                                                className={genStyles.inputtCol}
                                                type="text"
                                                value={form.polycontourColor}
                                                onChange={(e) => updateField("polycontourColor", e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col s4">
                                        <span className={`${genStyles.fontSize15}  black-text  ${genStyles.noMargin}`}>Opacité</span>
                                            <div className={genStyles.pickctn}>
                                            <input 
                                                className={genStyles.inputtCol}
                                                type="number"
                                                min="0"
                                                max="100"
                                                value={form.polycontourOpacity !== '' ? (form.polycontourOpacity * 100).toFixed(0) : ''}
                                                onChange={(e) => updateField("polycontourOpacity", e.target.value)}
                                            />
                                            <span> %</span>
                                            </div>
                                    </div>
                                    <div className="col s4">
                                        <span className={`${genStyles.fontSize15}  black-text  ${genStyles.noMargin}`}>Épaisseur</span>
                                        <input 
                                            className={genStyles.inputtCol}
                                            type="number"
                                            min="0"
                                            value={form.polycontourEpaisseur}
                                            onChange={(e) => updateField("polycontourEpaisseur", e.target.value)}
                                        />
                                    </div>
                                </div>   
                                <div className="row mb0">
                                    <div className="col s4">
                                        <span className={`${genStyles.fontSize15}  black-text  ${genStyles.noMargin}`}>Remplissage</span>
                                        <div className={genStyles.pickctn}>
                                            <DropdownSelect
                                                options={presetColors}
                                                selected={form.polyColor}
                                                onChange={(color) => updateField("polyColor", color)}
                                                type="color"
                                                showCustomColor={true}
                                            />                               
                                            <input 
                                                className={genStyles.inputtCol}
                                                type="text"
                                                value={form.polyColor}
                                                onChange={(e) => updateField("polyColor", e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col s4">
                                        <span className={`${genStyles.fontSize15}  black-text  ${genStyles.noMargin}`}>Opacité</span>
                                        <div className={genStyles.pickctn}>
                                            <input 
                                                className={genStyles.inputtCol}
                                                type="number"
                                                min="0"
                                                max="100"
                                                value={form.polyOpacity !== '' ? (form.polyOpacity * 100).toFixed(0) : ''}
                                                onChange={(e) => updateField("polyOpacity", e.target.value)}
                                            />
                                            <span> %</span>
                                        </div>
                                    </div>
                                </div>                  
                            </div>
                        </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="col s12">
                <div className={genStyles.modalActions}>
                    <button
                        className={`${genStyles.modalBtn} ${genStyles.modalBtnSecondary}`}
                        onClick={onClose}
                    >
                        Annuler
                    </button>
                    <button
                        className={`${genStyles.modalBtn} ${genStyles.modalBtnPrimary}`}
                        onClick={() => onValidate()}
                    >
                        Valider
                    </button>
                </div>
            </div>
        </div>
    );
}
